import styled from "@emotion/styled/macro";
import {ButtonBar} from "../../../../components";
import {Variables} from "@enter/core";
import {Field} from "formik";

export const FormContainer = styled.section`
    width: 100%;
    margin: 0 auto;
    display: flex;
`;

export const Wrapper = styled.div`
    padding: 20px 0;
`;


export const SubCategoryItem = styled.div`
    overflow: auto;
    padding: 40px;

    padding: 0px 24px;
    flex-grow: 1;
`;


export const DialogBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 24px;
    flex-grow: 1;
`;

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    font-size: 18px;
    line-height: 1.22;
    color: ${Variables.Colors.n70};
    margin-top: 16px;
    margin-bottom: 8px;
`;

export const FormField = styled(Field)`
    max-width: 420px;
    &:disabled {
        background-color: ${Variables.Colors.white};
    }
`;

export const ButtonGroup = styled(ButtonBar)`
    margin-top: 32px;
    margin-bottom: 16px;
`;


export const ActionsContainer = styled.div`
    position: fixed;
    right: 50px;
    bottom: 50px;
`;

